export interface Goals {
	goals: Goal[];
	goalLastSignedDate: Date;
	goalSignDateMentee: Date;
	goalSignDateMentor: Date;
}

export interface GoalAction {
	id: number;
	step: string;
	sequence: number;
	text: string;
	createdAt: Date;
}

export interface GoalStep {
	id: number;
	step: string;
	sequence: number;
	text: string;
	isFulfilled: boolean;
	createdAt: Date;
	updatedAt: Date | null;
}

export interface Goal {
	id: number;
	goal: string;
	change: string;
	priorities: string;
	achivmentPath: string;
	notes: string;
	deadlineAndReview: string;
	areaOfInfluence: string;
	steps?: GoalStep[];
	actions?: GoalAction[];
}

export enum ActionGoalId {
	new = -1,
}

export type GoalFields =
	| 'goal'
	| 'change'
	| 'priorities'
	| 'achivmentPath'
	| 'notes'
	| 'deadlineAndReview'
	| 'areaOfInfluence'
	| 'steps'
	| 'actions';
